module.exports = __webpack_public_path__ + "img/claim.b050b820.png";